import React, { memo } from "react";

import { HeaderGroup } from "react-table";
import styles from "./table.module.scss";

import { ReactComponent as ArrowIcon } from "static/images/arrow.svg";

type Props = {
	header: HeaderGroup;
};
// TODO: Optimize rerendering.
// It rerenders on each tick. Becasuse of header prop
const TableHeader = ({ header }: Props) => (
	<div {...header.getHeaderGroupProps()} className={styles.headers}>
		{header.headers.map(column => (
			<div
				{...column.getHeaderProps({
					...column.getSortByToggleProps(),
					className: `${styles.header} ${
						(column as any).classNameHeader
					}`,
				})}
			>
				<span className={styles.text}>{column.render("Header")}</span>
				<span className={styles.icon}>
					{column.canSort ? (
						column.isSorted ? (
							column.isSortedDesc ? (
								<ArrowIcon className={styles.descArrow} />
							) : (
								<ArrowIcon className={styles.ascArrow} />
							)
						) : (
							<ArrowIcon className={styles.inactiveArrow} />
						)
					) : null}
				</span>
			</div>
		))}
	</div>
);

const Component = memo(TableHeader);
export { Component as TableHeader };
